module.exports = __webpack_public_path__ + "cement/img/组 23100@2x.5028c1fb.png";